var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-toolbar',{staticClass:"background"},[_vm._v(" nice ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }